export default "__VITE_ASSET__DK3ndLci__"